<template>
  <v-container class="auth-sso-page" fluid>
    <v-row justify="center">
      <v-col cols="12" sm="8" md="6" lg="4" xl="3">
        <!-- Header -->
        <div class="text-center mb-6">
          <v-icon size="48" color="primary" class="mb-3"
            >mdi-badge-account-horizontal-outline</v-icon
          >
          <h1 class="text-h5 font-weight-bold mb-1">Single Sign-On</h1>
          <p class="text-body-2 text--secondary">
            Melde dich mit deinem Organisationskonto an.
          </p>
        </div>

        <!-- Placeholder card -->
        <v-card elevation="2" class="pa-6 text-center">
          <v-icon size="56" color="grey lighten-1" class="mb-4"
            >mdi-cog-outline</v-icon
          >
          <p class="text-body-1 font-weight-medium mb-1">
            Noch nicht verfügbar
          </p>
          <p class="text-body-2 text--secondary mb-5">
            SSO-Anmeldung ist noch in Vorbereitung.
          </p>
          <v-btn text :to="{ name: 'auth-login' }">
            <v-icon left>mdi-arrow-left</v-icon>
            Zurück zur Anmeldung
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "AuthLoginViaSSO",
};
</script>

<style scoped>
.auth-sso-page {
  min-height: 100vh;
  padding-top: 40px;
  padding-bottom: 60px;
}
</style>
